import { NavLink } from 'react-router-dom';
import versoLogo from '../../assets/verso-logo.svg';

// People-heads glyph for the Subscribers row — an inline SVG so it matches
// the visual weight of the other single-glyph icons and stays crisp on retina.
const PeopleIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className="h-4 w-4"
  >
    <circle cx="9" cy="8" r="3.25" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M3 19c0-3 2.7-5 6-5s6 2 6 5" />
    <path d="M15 19c0-2.2 1.7-4 4-4s2 1.3 2 3" />
  </svg>
);

// Nav items for the org dashboard. Overview is the landing page — for the
// first commit it's a minimal welcome; later it holds real-time KPIs. PBX
// Hosts lives under Settings → PBX Hosts, not in the top-level sidebar.
// Five items, in the order an operator thinks: who the customer is, what number
// they have, where it is, what hardware serves it.
//
// What is deliberately NOT here:
//
//   Extensions, Routes — implementation detail of a LINE, not objects an operator
//     manages on their own. An extension is how one PBX happens to realise a line;
//     a route is what that line's number points at. Managing them out of context
//     is how a route ended up aimed at an extension on a different host. Both are
//     now reached through the line that owns them, on the subscriber page. The
//     pages still exist at /extensions and /routes for debugging — just unlinked.
//   Alerts — already one click away from the bell in the top bar.
//   Audit Log — org_admin only, and in the avatar menu rather than here. It is a
//     forensic tool, not part of the daily path, and giving it top-level billing
//     invited using it as a status display (which is also how a filter that
//     silently ignores resource_id nearly produced a false incident report).
const NAV_ITEMS = [
  { to: '/',            label: 'Overview',    icon: '⊞' },
  { to: '/subscribers', label: 'Subscribers', icon: PeopleIcon },
  { to: '/dids',        label: 'DIDs',        icon: '#' },
  { to: '/locations',   label: 'Locations',   icon: '⌂' },
  { to: '/devices',     label: 'Devices',     icon: '▦' },
];

export default function Sidebar() {
  return (
    <aside className="flex w-56 flex-col border-r border-gray-200 bg-white">
      <div className="flex h-14 items-center border-b border-gray-200 px-3">
        <img src={versoLogo} alt="Verso" className="h-12" />
      </div>
      <nav className="flex-1 space-y-0.5 p-2">
        {NAV_ITEMS.map(({ to, label, icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
          >
            <span className="flex w-5 items-center justify-center">{icon}</span>
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
